export class ServiceDeliveryInfoConstants {
    public static readonly NON_PDG_PHONE_NUMBER = '800-952-4438';
}
